<div class="full_dialog">
    <div class="head_content">
        <div class="head_title">
            <img class="head_eye" src="assets/icones/eye_icon.svg" alt="">
            <h2>{{"quotations_and_orders.products_preview"| translate}}</h2>
        </div>
        <mat-icon (click)="close()">close</mat-icon>
    </div>
    <div class="card_info">
        <div class="summary_metrics">
            <div class="metric_group" *ngIf="data.parent">
                <div class="metric">
                    <span class="metric_label">{{"inventory.sku"| translate}}</span>
                    <span class="metric_value">{{compareProducts(data, data.parent).addedProducts.length}}</span>
                </div>
                <div class="metric">
                    <span class="metric_label">{{"quotations_and_orders.sku_cancelled"| translate}}</span>
                    <span class="metric_value">{{compareProducts(data, data.parent).removedProducts.length}}</span>
                </div>
                <div class="metric">
                    <span class="metric_label">{{"quotations_and_orders.qty_modified_on"| translate}}</span>
                    <span class="metric_value">{{compareProducts(data, data.parent).changedQuantityProducts.length}} SKU</span>
                </div>
                <div class="metric">
                    <span class="metric_label">{{"quotations_and_orders.price_modified_on"| translate}}</span>
                    <span class="metric_value">{{compareProducts(data, data.parent).changedPriceProducts.length}} SKU</span>
                </div>
            </div>
            <div class="metric_group">
                <div class="metric">
                    <span class="metric_label">{{"quotations_and_orders.number_of_sku"|translate}}</span>
                    <span class="metric_value">
                        <span class="new">{{data.nbr_products}}</span>
                        <span class="old_value" *ngIf="data.parent && data.parent.nbr_products !== data.nbr_products">{{data.parent.nbr_products}}</span>
                    </span>
                </div>
                <div class="metric" *ngIf="featureFlags.showTotalQuantity">
                    <span class="metric_label">{{"quotations_and_orders.total_quantities"|translate}}</span>
                    <span class="metric_value">
                        <span class="new">{{data.total_qty}}</span>
                        <span class="old_value" *ngIf="data.parent && data.parent.total_qty !== data.total_qty">{{data.parent.total_qty}}</span>
                    </span>
                </div>
                <div class="metric">
                    <span class="metric_label">{{"quotations_and_orders.total_purchase_amount"|translate}}</span>
                    <span class="metric_value">
                        <span class="new">{{getQuotationTotalPrice(data).toFixed(2)}}€</span>
                        <span class="old_value" *ngIf="data.parent && getQuotationTotalPrice(data.parent) !== getQuotationTotalPrice(data)">{{getQuotationTotalPrice(data.parent).toFixed(2)}}€</span>
                    </span>
                </div>
            </div>
        </div>
        <div class="files">
            <button class="document-action-button"
                    [title]="'quotations_and_orders.download_tooltip' | translate"
                    [matMenuTriggerFor]="downloadMenu">
                <img src="assets/icones/download.svg" alt="">
            </button>
            <mat-menu #downloadMenu="matMenu" xPosition="before" class="download-menu">
                <button mat-menu-item (click)="downloadFile()">
                    <img class="menu-icon" src="assets/icones/pdf-file.svg" alt="">
                    <span>{{ "quotations_and_orders.download_pdf" | translate }}</span>
                </button>
                <button mat-menu-item (click)="downloadFileCSV()">
                    <img class="menu-icon" src="assets/icones/csv-file.svg" alt="">
                    <span>{{ "quotations_and_orders.download_csv" | translate }}</span>
                </button>
            </mat-menu>
        </div>
    </div>
    <div class="list">
        <table>
            <tr class="tr head_row">
                <th class="img_clmn">{{"common.image"|translate}}</th>
                <th class="name_clmn">{{"common.name"|translate}}<br /><span class="sub_label">{{ productCode.primaryLabelKey | translate }}</span></th>
                <th class="number_clmn">{{"Catalogs.retail_price"| translate}}<br /><span class="sub_label">{{"quotations_and_orders.msrp"| translate}}</span></th>
                <th class="number_clmn">{{"quotations_and_orders.discount"|translate}}<br /><span class="sub_label">{{"quotations_and_orders.discount_on_msrp"| translate}}</span></th>
                <th class="number_clmn">{{"Catalogs.final_price"|translate}}</th>
                <th class="number_clmn">{{"quotations_and_orders.quantity"| translate}}</th>
                <th class="number_clmn">{{"quotations_and_orders.amount"| translate}}</th>
            </tr>
            <tr class="tr" *ngFor="let item of data.products">
                <td class="img_clmn">
                    <div class="img_product">
                        <span class="tag position_tag added-product" *ngIf="isAddedProduct(item)">{{'Added'}}</span>
                        <img [src]="item.image ? baseUrl + item.image + '?thumbnail=1' : placeholder" alt="">
                    </div>
                </td>
                <td class="name_clmn">
                    <div class="item_quantity">
                        <div class="bold_size1 truncate" [title]="item.name">{{item.name}}</div>
                        <span class="sku">{{item | productCode}}</span>
                    </div>
                </td>
                <td class="number_clmn">
                    <div class="cell_stack" *ngIf="getUnitPrice(item) || getOldPrice(item)">
                        <span class="bold_size1">{{ getUnitPrice(item) }}€</span>
                        <span class="old_price" *ngIf="getOldPrice(item) !== getUnitPrice(item)">{{getOldPrice(item)}}€</span>
                    </div>
                    <span class="empty_value" *ngIf="!getUnitPrice(item) && !getOldPrice(item)">--</span>
                </td>
                <td class="number_clmn">
                    <div class="cell_stack" *ngIf="item.discount || getOldDiscount(item)">
                        <span class="bold_size1">{{item.discount}}%</span>
                        <span class="old_price" *ngIf="getOldDiscount(item) !== item.discount">{{getOldDiscount(item)}}%</span>
                    </div>
                    <span class="empty_value" *ngIf="!item.discount && !getOldDiscount(item)">--</span>
                </td>
                <td class="number_clmn">
                    <div class="cell_stack">
                        <span class="bold_size1">{{getFinalPrice(item)}}€</span>
                        <span class="old_price" *ngIf="getOldFinalPrice(item) !== getFinalPrice(item)">{{getOldFinalPrice(item)}}€</span>
                    </div>
                </td>
                <td class="number_clmn">
                    <div class="cell_stack">
                        <span class="bold_size1">{{item.quantity}}</span>
                        <span class="old_price" *ngIf="getOldQuantity(item) !== item.quantity">{{getOldQuantity(item)}}</span>
                    </div>
                    <div class="info_hint">
                        <span>{{"quotations_and_orders.overall_quantity"| translate}}</span>
                        <button [matMenuTriggerFor]="beforeMenu" #menuTrigger="matMenuTrigger">
                            <img src="assets/icones/rule.svg" alt="">
                        </button>
                        <mat-menu #beforeMenu="matMenu" xPosition="before">
                            <div class="cover_div">
                                <div class="info_hint">
                                    <span>{{"quotations_and_orders.quantity_rule"| translate}}</span>
                                </div>
                                <div class="spans">
                                    <span>{{"Catalogs.min"|translate}} {{item.min_qte}}</span>
                                    <span>{{"Catalogs.max"|translate}} {{item.max_qte}}</span>
                                    <span>{{"Catalogs.increment"|translate }} {{item.increment}}</span>
                                </div>
                            </div>
                        </mat-menu>
                    </div>
                </td>
                <td class="number_clmn">
                    <div class="cell_stack">
                        <span class="bold_size1">{{getTotalAmount(item).toFixed(2)}}€</span>
                        <span class="old_price" *ngIf="getOldTotalAmount(item) !== getTotalAmount(item)">{{getOldTotalAmount(item).toFixed(2)}}€</span>
                    </div>
                </td>
            </tr>
            <!-- Displaying Deleted Products -->
            <tr class="tr deleted-product" *ngFor="let item of getDeletedProducts()">
                <td class="img_clmn">
                    <div class="img_product">
                        <span class="tag position_tag deleted-hint">{{'Deleted'}}</span>
                        <img [src]="item.image ? item.image : placeholder" alt="">
                    </div>
                </td>
                <td class="name_clmn">
                    <div class="item_quantity">
                        <span class="deleted bold_size1">{{item.name}}</span>
                        <span class="sku">{{item | productCode}}</span>
                    </div>
                </td>
                <td class="number_clmn">
                    <span class="old_price">{{item.price_unit}}€</span>
                </td>
                <td class="number_clmn">
                    <span class="bold_size1">{{item.discount}}%</span>
                </td>
                <td class="number_clmn">
                    {{ getFinalPrice(item) }}€
                </td>
                <td class="number_clmn">
                    <span class="old_price">{{item.quantity}}</span>
                </td>
                <td class="number_clmn">
                    {{ (getFinalPrice(item) * item.quantity).toFixed(2) }}€
                </td>
            </tr>
        </table>
    </div>
    <div class="foot_content">
        <button class="close_btn" (click)="close()">{{"common.close"| translate}}</button>
    </div>
</div>
